import {
    Component,
    EventEmitter,
    Input, OnInit,
    Output
} from '@angular/core';
import {UntypedFormControl, UntypedFormGroup, Validators} from "@angular/forms";
import {Line} from "@models/line.model";
import {Log} from "ng2-logger";

@Component({
    selector: 'app-tool-main-line-form',
    templateUrl: './tool-main-line-form.component.html',
    styleUrls: ['./tool-main-line-form.component.scss']
})

export class ToolMainLineFormComponent implements OnInit {
    _logger = Log.create(ToolMainLineFormComponent.name);

    @Input() selectedLine: Line;
    @Input() lines: Line[];
    @Input() showValidations = false;
    @Input() disabled = false;

    @Output() changedLine = new EventEmitter<any>();

    public form: UntypedFormGroup;

    constructor() {
    }

    ngOnInit() {
        this.form = new UntypedFormGroup({
            line: new UntypedFormControl(this.selectedLine, Validators.required),
        });
    }

    get value() {
        return this.form.value;
    }
}
